export enum ECustomFieldType {
  NUMBER = 'number',
  DATE = 'date',
  STRING = 'string',
  DROPDOWN = 'dropdown',
}

export interface ICustomField {
  id :number;
  label :string;
  type :string;
  updated_at :Date;
  created_at :Date;
  options ?:Array<string>;
  value ?:string;
  customFieldObjects ?:ICustomFieldObject[];
  customFieldObjectsLabel ?:string[];
  customFieldObjectTypes ?:string[];
  custom_field_object_types?: string[];
}

export interface ICustomFieldValue {
  id :number;
  custom_field_id :number;
  model_id :number;
  model_type :string;
  value_string :string;
  value_number :number;
  value_date :Date;
  created_at :Date;
  updated_at :Date;
  custom_field :ICustomField;
  customField :ICustomField;
}

export interface ICustomFieldFormValue {
  custom_field :number;
  value :any;
}

export interface ICustomFieldValueUI {
  id :number;
  label :string;
  value :string | number | Date;
}

export enum ECustomFieldDetailsView {
  LIST = 'list',
  TABLE = 'table',
}

export enum ECustomFieldObject {
  SALES_ORDER = 'salesOrder',
  RFQ = 'rfq',
  SUPPLIER_PURCHASE_ORDER = 'supplierPurchaseOrder',
  ASSEMBLY_ORDER = 'assemblyOrder',
  DISASSEMBLY_ORDER = 'disassemblyOrder',
  CLIENT_INVOICE = 'clientInvoice',
  BUSINESS_ACCOUNT = 'businessAccount',
  SALES_ORDER_ITEM = 'salesOrderItem',
}

export const CUSTOM_FIELD_OBJECTS = [
  { label: 'Sales Order', value: ECustomFieldObject.SALES_ORDER },
  { label: 'Sales Order Item', value: ECustomFieldObject.SALES_ORDER_ITEM },
  { label: 'SKU', value: ECustomFieldObject.RFQ },
  { label: 'Supplier Purchase Order', value: ECustomFieldObject.SUPPLIER_PURCHASE_ORDER },
  { label: 'Assembly Order', value: ECustomFieldObject.ASSEMBLY_ORDER },
  { label: 'Disassembly Order', value: ECustomFieldObject.DISASSEMBLY_ORDER },
  { label: 'Client Invoice', value: ECustomFieldObject.CLIENT_INVOICE },
  { label: 'Business Account', value: ECustomFieldObject.BUSINESS_ACCOUNT },
];

export interface ICustomFieldObject {
  id ?:number;
  customFieldId ?:number;
  objectType :string;
}
